<app-reset-password *ngIf="this.resetPasswordData" [resetPasswordData]="resetPasswordData"></app-reset-password>

<div *ngIf="!resetPasswordData" class="col-md-6 offset-md-3 mt-5 display-inline-block">
  <div class="card">
    <h4 class="card-header"><i class="material-icons">key</i>{{'login.title' | translate}}</h4>
    <div class="card-body">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label>{{'login.username' | translate}}</label>
          <input
            type="text"
            formControlName="username"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f['username'].errors }"
          />
          <div *ngIf="submitted && f['username'].errors" class="invalid-feedback">
            <div *ngIf="f['username'].errors['required']">Username is required</div>
          </div>
        </div>

        <div class="form-group">
          <label>{{'login.password' | translate}}</label>
          <input
            type="password"
            formControlName="password"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f['password'].errors }" />
          <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
            <div *ngIf="f['password'].errors['required']">Password is required</div>
          </div>
        </div>

        <div class="forget-password-text" (click)="onClickForgotPassword()">{{'login.forgot_password.button_text' | translate}}</div>

        <button [disabled]="loading" class="btn btn-primary">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Login
        </button>
      </form>
    </div>
  </div>

  <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
</div>
